"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Integration_module_css_1 = __importDefault(require("../Integration.module.css"));
var react_i18next_1 = require("react-i18next");
var react_json_view_lite_1 = require("react-json-view-lite");
require("react-json-view-lite/dist/index.css");
var DataPreviewModal = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(undefined), jsonData = _a[0], setJsonData = _a[1];
    var handleCopy = function () {
        if (jsonData) {
            navigator.clipboard.writeText(JSON.stringify(jsonData, null, 2))
                .then(function () {
                alert("Copied JSON to clipboard!");
            })
                .catch(function (err) {
                alert("Failed to copy JSON:");
            });
        }
    };
    (0, react_1.useEffect)(function () {
        var loadResourceData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a, _b, _c;
            var _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, fetch(props.resource.file)];
                    case 1:
                        response = _h.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 3];
                        _a = setJsonData;
                        _d = {};
                        _e = {
                            variables: {}
                        };
                        _f = {};
                        _b = props.resource.script_identifier;
                        _g = {};
                        _c = props.resource.template_identifier;
                        return [4 /*yield*/, response.json()];
                    case 2:
                        _a.apply(void 0, [(_d.data = (_e.resources = (_f[_b] = (_g[_c] = _h.sent(),
                                _g),
                                _f),
                                _e.settings = {},
                                _e),
                                _d)]);
                        _h.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadResourceData();
    }, []);
    var ModalHeader = function () {
        return (react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
            t("Preview"),
            ":"));
    };
    var ModalBody = function () {
        return (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "10px" } },
            react_1.default.createElement("div", { className: Integration_module_css_1.default["ns-page-card"], style: { width: "100%", minHeight: "550px", maxHeight: "550px", padding: 0, overflowY: "scroll", overflowX: "auto" } },
                react_1.default.createElement("div", { style: {
                        padding: "10px",
                        background: "#f5f5f5",
                        borderRadius: "4px",
                        userSelect: "text",
                    } },
                    react_1.default.createElement(react_json_view_lite_1.JsonView, { data: jsonData ? jsonData : {}, style: react_json_view_lite_1.defaultStyles }))),
            react_1.default.createElement("button", { onClick: handleCopy, style: {
                    alignSelf: "flex-end",
                    padding: "8px 12px",
                    border: "none",
                    borderRadius: "4px",
                    backgroundColor: "var(--info-color)",
                    color: "#fff",
                    cursor: "pointer"
                } }, t("Copy JSON"))));
    };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: props.onClose, header: react_1.default.createElement(ModalHeader, null), body: react_1.default.createElement(ModalBody, null), dialogClassName: Integration_module_css_1.default["integration-script-debug-modal"], centered: true }));
};
exports.default = DataPreviewModal;
